// Constellation
import { ToggleButton, ToggleButtonGroup } from '@zillow/constellation';

// Components
import FilterWrapper from '../FilterWrapper';

// Flux
import { useAppSelector } from '../../flux/configureStore';

// Misc / Utils
import { useOptimisticState } from '../../utils/hooks';
import * as S from './styles';

// Types
import type { PartialFilterType } from '../../models/Types';

const Distance = ({ onFilterChange }: { onFilterChange: (arg0: PartialFilterType) => void }) => {
  const distanceFilterRedux = useAppSelector((state) => state.filter.distanceInMiles);
  const [distanceFilter, setDistanceFilter] = useOptimisticState(distanceFilterRedux);
  const distanceStr = distanceFilter ? distanceFilter.toString() : '';

  const handleFilterClick = (_distance: string) => {
    // ToggleButtonGroup only returns string values
    const distance = Number(_distance);

    // cannot deselect current selection
    if (distance == distanceFilter) {
      return false;
    }

    const action = distance !== 0 ? 'Distance::' + distance + 'miles' : 'Distance::Any';
    setDistanceFilter(distance || null);
    onFilterChange({ distanceInMiles: distance || null });
  };

  // ToggleButtonGroup only accepts string values
  const component = (
    <S.Container>
      {/* @ts-expect-error */}
      <ToggleButtonGroup defaultValue={distanceStr} onChange={handleFilterClick} aria-label="Distance filter">
        <ToggleButton value="">Any</ToggleButton>
        <ToggleButton value="1">1</ToggleButton>
        <ToggleButton value="2">2</ToggleButton>
        <ToggleButton value="3">3</ToggleButton>
        <ToggleButton value="4">4</ToggleButton>
        <ToggleButton value="5">5</ToggleButton>
      </ToggleButtonGroup>
    </S.Container>
  );

  return FilterWrapper({
    heading: 'Distance from your home (in miles)',
    children: component,
  });
};

export default Distance;
